module.exports = __webpack_public_path__ + "img/Analytics & Reporting Utilization Data.10b3b84e.jpeg";